import { Injectable, inject } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, map, mergeMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class TitleService {
  private readonly appName = "DevProRH Front";

  private readonly title = inject(Title);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  /**
   * Initialize the title service to update the title based on route data
   */
  init(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === "primary"),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        const routeTitle = data["title"] || "";
        if (routeTitle) {
          this.setTitle(`${routeTitle} - ${this.appName}`);
        } else {
          this.setTitle(this.appName);
        }
      });
  }

  /**
   * Sets the document title
   * @param title The title to set
   */
  setTitle(title: string): void {
    this.title.setTitle(title);
  }
}
